// @ts-ignore
import * as d3 from "d3";
import React, { useRef, useEffect } from "react";

function SparkChart({
  data,
  config = {
    fill: "rgb(237, 131, 11)",
    fadeFill: "rgba(237, 131, 11,0.1)",
    threshold1: 75,
    thresholdFill1: "rgb(192,0,0)",
    threshold2: 85,
    thresholdFill2: "rgb(255,195,0)",
    lineStroke: "0.5px",
    delay: 200,
    duration: 500,
  }
}) {
  var linePath = "M00";
  var areaPath = "M00";

  const containerWidth = 155,
    containerHeight = 25,
    margin = { top: 0, right: 0, bottom: 0, left: 0 },
    width = containerWidth - margin.left - margin.right,
    height = containerHeight - margin.top - margin.bottom;

  const gRef = useRef(null);
  const areaRef = useRef(null);
  const lineRef = useRef(null);

  useEffect(() => {

    // Add the area path.
    d3.select(areaRef.current)
      .attr("id", "spark-area");
    //   .attr("fill", "url(#gradient)");

    // Add the line path.
    d3.select(lineRef.current)
      .attr("id", "spark-line")
      .style("fill", "none")
      .style("stroke-width", config.lineStroke);

  }, []);

  useEffect(() => {
  
    // set the domain/range
    var x = d3.scaleLinear().range([0, width]);
    var y = d3.scaleLinear().range([height, 0]);

    x.domain(
      d3.extent(data, function (d,i) {
        return i;
      })
    );

    y.domain([
      d3.min(data, function (d) {
        return Math.min(d.value * 0.95);
      }),
      d3.max(data, function (d) {
        return Math.max(d.value * 1.05);
      }),
    ]);

    // Define the area
    var area = d3
      .area()
      .x(function (d, i) {
        return x(i);
      })
      .y0(function (d) {
        return y(
          d3.min(data, function (d) {
            return Math.min(d.value * 0.95);
          })
        );
      })
      .y1(function (d) {
        return y(d.value);
      })
      .curve(d3.curveCardinal);
    // Define the Demand line
    var line = d3
      .line()
      .x(function (d, i) {
        return x(i);
      })
      .y(function (d) {
        return y(d.value);
      })
      .curve(d3.curveCardinal);

    areaPath = area(data);

    linePath = line(data);

    d3.select(areaRef.current).attr("d", areaPath);

    d3.select(lineRef.current).attr("d", linePath);

  }, [data]);



  return (
    <div>
      <svg viewBox={"0 0 " + containerWidth + " " + containerHeight}>
        <g
          ref={gRef}
          transform={"translate(" + margin.left + "," + margin.top + ")"}
        >

           <linearGradient id="area-gradient" gradientUnits="userSpaceOnUse" x1="0%" y1="100%" x2="0%" y2="0%">
           <stop offset="0%" stopColor={config.fadeFill} stopOpacity="0"/>
          <stop offset="100%" stopColor={config.fill} stopOpacity="1"/>

        </linearGradient>
          <path ref={areaRef} fill="url(#area-gradient)"/>
          <path ref={lineRef} stroke={config.fill} />

        </g>
      </svg>
    </div>
  );
}

export default SparkChart;
